import wordmarkWebp from "../assets/wordmark.webp";
import wordmarkPng from "../assets/wordmark.png";

const WORDMARK_WIDTHS = {
  xl: "w-[300px] md:w-[380px]",
  lg: "w-[220px] md:w-[260px]",
  md: "w-[170px] md:w-[190px]",
  // sm is the auth-page hero size. Mobile shrinks to a phone-safe 260px
  // while preserving the full 472px on tablets/desktops (≥768px). Aspect
  // ratio is auto via `h-auto` on the <img> tag.
  sm: "w-[260px] md:w-[472px]",
};

/**
 * Nombase Connect wordmark.
 *
 * Source PNG was 2.1 MB and lived on the customer-assets CDN — caused a
 * ~2 second blocking download on cold loads. Bundled locally now, resized
 * to exact 2x retina at the max render width (944×629), emitted as both
 * WebP (~48 KB) and PNG (~116 KB fallback). Same aspect ratio and
 * proportions as the original PNG so all the existing layout numbers
 * (w-432/472, -mt-12/-16) still work without any changes.
 */
export default function NombaseWordmark({ size = "sm", variant = "light" }) {
  const widthClass = WORDMARK_WIDTHS[size] || WORDMARK_WIDTHS.sm;
  const isLight = variant === "light";

  return (
    <picture data-testid="nombase-logo">
      <source srcSet={wordmarkWebp} type="image/webp" />
      <img
        src={wordmarkPng}
        alt="Nombase Connect"
        className={`${widthClass} h-auto select-none pointer-events-none`}
        style={{
          filter: isLight ? "invert(1)" : "none",
          mixBlendMode: isLight ? "multiply" : "normal",
        }}
        draggable={false}
        decoding="async"
        fetchPriority="high"
      />
    </picture>
  );
}
